<template>
  <div>
  <!-- <vue-scroll class="card-base card-shadow--medium mb-30" style="height:400px"> -->
    <div class="p-20 flex">
      <div class="box">
        <h4 v-if="title" class="mv-0">{{title}}</h4>
        <h4 v-else class="mv-0">{{$('dashboards.sales-order-dashboard')}}</h4>
      </div>
      <div class="box center"></div>
      <div class="box">
        <el-button :icon="loadingIcon" class="mr-5" size="small" @click="refresh" style="float:left;"></el-button>
        <el-dropdown v-if="id!=null">
          <el-button size="small">
            <i class="el-icon-more-outline"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown" size="small">
            <el-dropdown-item :disabled="true"><i class="el-icon-setting"></i>{{$t('common.Configure')}}</el-dropdown-item>
            <el-dropdown-item @click.native="handleDelete" ><i class="el-icon-delete"></i>{{$t('common.Delete')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-skeleton :count="1" animated :loading="loading">
      <template slot="template">
        <tableSkeleton :rows="parseInt((height-250)/40) || 1" :height="height-250" :columnLabel="[{ label:' ', width:50, sortable:false}, {label: 'Numéro', width:150, sortable:true}, {label: 'Client', sortable:true}, { label: 'Date',width: 100, sortable:true}, {label: 'Date de livraison', width: 100, sortable:true}, {label: 'Type de livraison', sortable:true}, {label: 'Statut', sortable:true}, {label: 'Étiquettes', sortable:false}]"></tableSkeleton>
      </template>
      <template>
        <salesOrderTable class="mb-20" :salesOrders="salesOrders" :customerId="customerId" :showDeliveryDate="showDeliveryDate" :height="height-250"></salesOrderTable>
      </template>
    </el-skeleton>
    <div class="m-20 flex justify-space-between" style="display:absolute; top:20px;">
      <h4 class="mt-5 mb-0 o-050 fs-14 secondray-text">{{count}} {{$t('sales_orders.Sales-orders-displayed')}} {{totalCount}}</h4>
      <Pagination
        class="mt-5 mb-0 fs-14 secondary-text"
        :current-page="page"
        :total-number-of-page="totalPages"
        @click-previous="clickPrevious"
        @click-next="clickNext" />
    </div>
  </div>
  <!-- </vue-scroll> -->
</template>
<script>
import salesOrderTable from './sales-order-table'
import salesOrderAPI from '@/services/API/sales-order';
import moment from 'moment-timezone'
import tableSkeleton from '@/components/skeleton/table-skeleton'
import Pagination from '@/components/pagination.vue';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'sales-order-dashboard-card',
	props: {
    uuid: {
      type: String
    },
    id : {
      type : Number
    },
    position : {
      type : Number,
      required: true
    },
    showDeliveryDate : {
      type : Boolean,
      default : false
    },
    repFilters : {
      type : Boolean,
      default : true
    },
    customerId : null,
    filters : {
      type : Object
    },
    limit : {
      type : String,
      default : null
    },
    defaultType : {
      type : String,
      default : null
    },
    salesReps : {
      type : Array
    },
    title : {
      type : String,
      default : null
    },
    criterias : {
      type : Array
    },
    customerClasses : {
      type : Array
    },
    inventories: {
      type : Array
    },
    productId : {
      type : Number
    },
    height: {
      type: Number
    }
	},
  data() {
    return {
      salesOrders : [],
      type : 'CONFIRMED',
      loading : false,
      user : null,
      timer : '',
      totalCount : null,
      page: 1,
      totalPages : null,
    };
  },components: {
    salesOrderTable,
    tableSkeleton,
    Pagination
  },
  watch : {
    type : function(newVal, oldVal){
      if(newVal!=oldVal){
        this.fetchSalesOrders();
      }
    }
  },
	methods: {
    handleDelete(){
      this.deleteDashboard(this.id)
        .then(()=>{
          this.$message({
          message: 'Le canal a été supprimé avec succès.',
          type: 'success'
        });
        })
    },
    clickPrevious () {
      if (this.page > 1) {
          this.page -= 1;
      }
      this.refresh();
    },
    clickNext () {
      if (this.page < this.totalPages) {
        this.page += 1;
        this.refresh();
      }
    },
    refresh () {
      this.cancelAutoUpdate();
      this.fetchSalesOrders()
        .then(() => this.createTimer());
    },
    fetchSalesOrders(){
      this.loading =true;
      let params = {};

      params.statusCode = [];
      _.forEach(this.filters, (value, key)=>{
        if(value)params.statusCode.push(key);
      });

      params.reps = this.salesReps?this.salesReps:undefined;

      if(this.criterias!=null){
        _.forEach(this.criterias, criteria=>{
          if(criteria.field==='Date'){
            if(criteria.selectedOperator==='='){
              params.date=moment().format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='>='){
              params.startDate=moment().format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='>'){
              params.startDate=moment().add(1,'day').format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='<'){
              params.endDate=moment().subtract(1,'day').format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='<='){
              params.endDate=moment().format('YYYY-MM-DD Z');
            }
          }
        })
      }

      if (!_.isEmpty(this.inventories)) {
        params.inventoryId = _.map(this.inventories, inv => inv.id);
      }
      params.customerClassId = this.customerClasses ? this.customerClasses : undefined;
      params.productId = this.productId ? this.productId : undefined;

      if(this.customerId)params.customerId=this.customerId;
      // params.paging='no';
      params.limit = 50;
      params.page = this.page;
      params.orderBy="date";
      params.direction="ASC";



      return salesOrderAPI.fetchSalesOrders(params, ['customer'])
        .then(salesOrders=>{
          this.salesOrders = salesOrders.list;
          this.totalCount = salesOrders.count;
          this.totalPages = salesOrders.pages;
          this.updateTotalElement({ uuid: this.uuid, totalElement: this.totalCount});
          this.loading=false;
        })

    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);

    },
    date(so){
      if(this.filters){
        let status = _.find(so.status_logs, status=>{return status.code==this.type});
        if(status==null)return false;
        return status.status_log.created_at;
      }else{
        return so.date;
      }

    },
    isConfirmed(so){
      return so.status.code=="CONFIRMED";
    },
    isVoided(so){
      return so.status.code=="VOIDED";
    },
    isActive(so){
      if(this.type=="SET_ASIDE"){
        let status = _.find(so.status_logs, status=>{return status.code==this.type});
        if(status==null)return false;
        var current = moment().startOf('day');
        var statusDate = moment(status.status_log.created_at).startOf('day');
        var duration = moment.duration(statusDate.diff(current)).asDays();
        return duration >= -19;
      }
      return false;
    },isIntermediary(so){
      if(this.type=="SET_ASIDE"){
        let status = _.find(so.status_logs, status=>{return status.code==this.type});
        if(status==null)return false;
        var current = moment().startOf('day');
        var statusDate = moment(status.status_log.created_at).startOf('day');
        var duration = moment.duration(statusDate.diff(current)).asDays();
        return duration < -19;
      }
      return false;
    },
    setSalesRepId(userId){
      this.fetchSalesOrders();
    },
    openSalesOrder(salesOrderId){
      var index='/sales-orders/'+salesOrderId;
      this.$router.push(index);
    },
    openCustomer(customerId){
      var index='/customers/'+customerId;
      this.$router.push(index);
    },
    createTimer () {
      this.timer = setInterval(this.fetchSalesOrders, 60000 + (this.position * 2000));
    },
    cancelAutoUpdate () { clearInterval(this.timer) },
    ...mapActions('users',['fetchAdminUsers']),
    ...mapActions('genericDashboards', ['updateTotalElement', 'deleteDashboard']),
	},
	computed: {
    loadingIcon(){
      if(this.loading)return 'el-icon-loading'
      else return 'el-icon-refresh'
    },
    count(){
      if(this.salesOrders==null)return 0;
      else return this.salesOrders.length;

    },
    ...mapGetters('users', [ 'filterUserWithRoleRep']),
	},
  created(){
    if(this.defaultType!=null){
      this.type = this.defaultType;
    }

    this.fetchSalesOrders()
      .then(() => this.createTimer())

    this.fetchAdminUsers();
  },
  beforeDestroy () {
    this.cancelAutoUpdate();
  }
}
</script>
<style lang="scss" scoped>




</style>
